import { isNull } from "lodash";

export const fromJson = <T>(json: string): T | undefined => {
  try {
    return JSON.parse(json) as T;
  } catch {}
};

export const toJson = <T>(data: T | null): string | null => {
  return isNull(data) ? null : JSON.stringify(data);
};
